import React from "react";

const TopMenu = () => {
    return (
        <div className="topmenu">
            <ul id="topmenu_mien_home">
                <li><a href="/" className="home">Home</a></li>
                <li><a href="/">Miền Nam</a></li>
                <li className="limientrung"><a href="/">Miền Trung</a></li>
                <li className="mienbacdientoan"><a href="/">Miền Bắc & Điện Toán</a></li>
            </ul>
        </div>
    )
};
export default TopMenu;
